// const chartColors = ['#0047BB', '#05A9B1', '#8C959B', '#F68D2E', '#65BD18', '#00A9E0']

const chartColors = [
  // '#0FACE7', // Sky
  // '#ACBCC9', // Silver
  // '#F44821', // Orange
  //'#696788', // 40% Light Navy
  '#373461', // 80% Navy
  '#3DD6DC', // 80% Teal
  '#336CC9', // 80% Blue
  '#E5D555', // 80% Gold
  '#7380F8', // 80% Iris
  '#7C858D', // 80% Gray
  '#3FBDEC', // 80% Sky
  '#BDC9D4', // 80% Silver
  '#F66D4D', // 80% Orange
  '#696788', // 60% Navy
  '#6EE0E5', // 60% Teal
  '#6691D6', // 60% Blue
  '#EBDF80', // 60% Gold
  '#96A0FA', // 60% Iris
  '#9DA4A9', // 60% Gray
  '#6FCDF1', // 60% Sky
  '#CDD7DF', // 60% Silver
  '#F8917A', // 60% Orange
]
export function labelPrependAsType(type, ccy) {
  if (type === 'b') {
    return currencySymbol(ccy)
  } else {
    return ''
  }
}

export function labelAppendAsType(type) {
  switch (type) {
    case '%':
      return '%'
    case 'b':
      return 'B'
    default:
      return ''
  }
}

export function valueAsType(value, type) {
  switch (type) {
    case '.':
      return value.toFixed(2)
    case '%':
      return value.toFixed(2)
    case '100%':
      return (value * 100).toFixed(2)
    case 'b':
      return value.toFixed(2)
    default:
      return value
  }
}

export function normalize(val, minmax) {
  if (!minmax) {
    return val
  }

  if (val < minmax[0]) {
    return undefined
  } else if (val > minmax[1]) {
    return undefined
  } else {
    return val
  }
}

export function getSortedData(data) {
  //simple desc sort on values array
  let keys = [...data.keys]
  let values = [...data.values]
  const ix = keys.map((x, i) => i)
  ix.sort((a, b) => values[b] - values[a])
  values = ix.map(x => values[x])
  keys = ix.map(x => keys[x])
  data.keys = keys
  data.values = values
  return data
}

export function getEarningsTimeSeriesChart(data, charName, type) {
  const legendData = []
  const seriesData = []

  if (type === 'growth') {
    //sales
    const growthSalesVals = data.map(fund => {
      // fund.salesBlendedGrowth
      return (fund.salesBlendedGrowth * 100).toFixed(1)
    })
    //earnings
    const growthEarningsVals = data.map(fund => {
      // fund.epsBlendedGrowth
      return (fund.epsBlendedGrowth * 100).toFixed(1)
    })

    legendData.push('Earnings Growth')
    legendData.push('Sales Growth')
    seriesData.push({ name: 'Earnings Growth', info: charName, type: 'line', data: growthEarningsVals.reverse() })
    seriesData.push({ name: 'Sales Growth', info: charName, type: 'line', data: growthSalesVals.reverse() })
  } else if (type === 'surprise') {
    const surpriseEarningsVals = data.map(fund => {
      // fund.epsSurprise
      return (fund.epsSurprise * 100).toFixed(1)
    })
    //earnings
    const surpriseSalesVals = data.map(fund => {
      // fund.epsBlendedGrowth
      return (fund.salesSurprise * 100).toFixed(1)
    })
    legendData.push('Earnings Surprise')
    legendData.push('Sales Surprise')
    seriesData.push({ name: 'Earnings Surprise', info: charName, type: 'line', data: surpriseEarningsVals.reverse() })
    seriesData.push({ name: 'Sales Surprise', info: charName, type: 'line', data: surpriseSalesVals.reverse() })
  }

  const displayRange = data
    .map(fund => {
      if (fund.displayRange) {
        return fund.displayRange
      } else {
        return null
      }
    })
    .reverse()

  // const ticker = data.ticker
  const xaxisData = [...displayRange]

  let minValue = -90
  let maxValue = 90
  // create the chart option with data
  return {
    title: {
      text: '',
      left: 5,
      show: true,
      textStyle: {
        fontStyle: 'normal',
        fontWeight: 900,
        fontSize: 12,
        color: '#050139'
      }
    },
    legend: {
      itemGap: 10,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#05A9B1',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },

    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#050139',
          rotate: 45,
          align: 'right',
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        min: minValue,
        max: maxValue,
        axisLabel: {
          fontSize: 12,
          color: '#050139',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}

export function getEarningsChart(data, type) {
  if (type === 'salesSurprise') {
    data.sort(function (a, b) {
      return parseFloat(b.salesSurprise) - parseFloat(a.salesSurprise)
    })
  }

  if (type === 'earningsSurprise') {
    data.sort(function (a, b) {
      return parseFloat(b.epsSurprise) - parseFloat(a.epsSurprise)
    })
  }

  if (type === 'salesGrowth') {
    data.sort(function (a, b) {
      return parseFloat(b.salesBlendedGrowth) - parseFloat(a.salesBlendedGrowth)
    })
  }
  if (type === 'earningsGrowth') {
    data.sort(function (a, b) {
      return parseFloat(b.epsBlendedGrowth) - parseFloat(a.epsBlendedGrowth)
    })
  }

  // populate yaxisData
  const vals = data.map(fund => {
    if (fund.salesSurprise && type === 'salesSurprise') {
      return (fund.salesSurprise * 100).toFixed(1)
    } else if (fund.epsSurprise && type === 'earningsSurprise') {
      return (fund.epsSurprise * 100).toFixed(1)
    } else if (fund.salesBlendedGrowth && type === 'salesGrowth') {
      return (fund.salesBlendedGrowth * 100).toFixed(1)
    } else if (fund.epsBlendedGrowth && type === 'earningsGrowth') {
      return (fund.epsBlendedGrowth * 100).toFixed(1)
    } else {
      return 0
    }
  })

  const sectors = data.map(fund => {
    if (fund.tierTwo) {
      return fund.tierTwo
    } else {
      return null
    }
  })

  const xaxisData = [...sectors]
  let idx = 0
  for (const entry of [...vals]) {
    if (entry === 0) {
      vals.splice(idx, 1)
      sectors.splice(idx, 1)
      xaxisData.splice(idx, 1)
    } else ++idx
  }

  const ticker = data[0].ticker

  let itemIndex = xaxisData.findIndex(item => item === 'Index')
  if (itemIndex !== -1) {
    const source = {
      value: vals[itemIndex],
      itemStyle: {
        color: '#8c959b'
      }
    }

    vals[itemIndex] = source
  }
  const seriesData = []
  seriesData.push({ name: ticker, type: 'bar', data: vals })


  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: []
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#050139',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },

    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#050139',
          rotate: 60,
          interval: 0,
          align: 'right',
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#050139',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}
function currencySymbol(ccy) {
  switch (ccy) {
    case 'USD':
    case 'CAD':
      return '$'
    case 'CHF':
      return 'CHF '
    case 'EUR':
      return '€'
    default:
      return ''
  }
}
function getLegendData(data) {
  return data.map(fund => {
    return fund.ticker
  })
}

export function getEarningsFutureChart(data, type) {
  console.log('data', data)
  console.log('type', type)
  // populate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const years = data.map(fund => fund.displayRange || null);
  const xaxisData = [...new Set(years)].map(year => year.replace('A-', ''));
  const seriesData = []
  const tickers = [...new Set(data.map(fund => fund.ticker))] // get unique tickers

  tickers.forEach(ticker => {
    const vals = xaxisData.map(year => {
      const fund = data.find(f => {
        // Create a local copy of displayRange for comparison
        let displayRangeModified = f.displayRange ? f.displayRange.replace('A-', '') : '';
        return f.ticker === ticker && displayRangeModified === year;
      });
      if (fund) {
        if (fund.cf_opCalYrGrw && type === 'cashflow') {
          return (fund.cf_opCalYrGrw * 100).toFixed(1);
        } else if (fund.salesCalYrGrw && type === 'sales') {
          return (fund.salesCalYrGrw * 100).toFixed(1);
        } else if (fund.ebitCalYrGrw && type === 'ebit') {
          return (fund.ebitCalYrGrw * 100).toFixed(1);
        }
      }
      return 0;
    });
    // Process vals here to ensure no duplication in the final output
    // For example, ensure vals is aggregated or used correctly


    seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: vals });
    console.log('seriesData', seriesData)
  });
  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          rotate: 45,
          interval: 0,
          align: 'right',
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }

}


// WEBPACK FOOTER //
// ./src/components/App/charts.js